import React, { useEffect } from 'react';
import { motion, useMotionValue, useSpring, useReducedMotion } from 'framer-motion';
import useMediaQuery from '../hooks/useMediaQuery';

const SIZE = 600;

// Cursor-following radial glow inside a container. Desktop pointers only.
const Spotlight = ({ containerRef }) => {
  const finePointer = useMediaQuery('(pointer: fine)');
  const reducedMotion = useReducedMotion();
  const x = useMotionValue(-SIZE);
  const y = useMotionValue(-SIZE);
  const sx = useSpring(x, { stiffness: 150, damping: 20, mass: 0.5 });
  const sy = useSpring(y, { stiffness: 150, damping: 20, mass: 0.5 });

  const active = finePointer && !reducedMotion;

  useEffect(() => {
    const el = containerRef.current;
    if (!active || !el) return undefined;
    const onMove = (e) => {
      const rect = el.getBoundingClientRect();
      x.set(e.clientX - rect.left - SIZE / 2);
      y.set(e.clientY - rect.top - SIZE / 2);
    };
    el.addEventListener('pointermove', onMove);
    return () => el.removeEventListener('pointermove', onMove);
  }, [active, containerRef, x, y]);

  if (!active) return null;

  return <motion.div className="hero__spotlight" style={{ x: sx, y: sy }} aria-hidden="true" />;
};

export default Spotlight;
